import type { Nullable } from "shared/domain/types/utils.types";

import { MAP_MONTHS } from "../constants/mappedMonth";

export const getResetMonth = (month: Nullable<number>) => {
  if (!month) return "-";

  return `1 ${MAP_MONTHS[month]}`;
};

export const getFormattedDaysValue = (days: Nullable<number>) => {
  if (!days) return "-";

  let daysLabel = "día";

  if (days !== 1) {
    daysLabel = "días";
  }

  return `${days} ${daysLabel}`;
};

export const getFutureDatesValue = (value: Nullable<number>) => {
  if (value === null || value === undefined) return "-";

  if (!value) return "Sin anticipación";

  return getFormattedDaysValue(value);
};

export const getPastDatesValue = (value: Nullable<number>) => {
  if (value === null || value === undefined) return "-";

  if (!value) return "No permitidas";

  return getFormattedDaysValue(value);
};

export const getBalanceControlValue = (hasBalanceControl: Nullable<boolean>) => {
  if (hasBalanceControl === null || hasBalanceControl === undefined) return "-";

  if (!hasBalanceControl) return "No";

  return "Sí";
};
